var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("数据看板")]),
              _c("el-breadcrumb-item", [_vm._v("数据运营")]),
              _c("el-breadcrumb-item", [_vm._v("Dcops工单运营")]),
              _c("el-breadcrumb-item", [_vm._v("服务器搬迁")])
            ],
            1
          )
        ],
        1
      ),
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "search-title" }, [
          _c("i", { staticClass: "el-icon-search" }),
          _vm._v("\n      搜索条件\n    ")
        ]),
        _c("div", { staticClass: "search-hint" }, [
          _vm._v("提示：先选择周期类型，再选择当前周期和对比周期。")
        ]),
        _c("div", { staticClass: "filter-row" }, [
          _c(
            "div",
            { staticClass: "filter-block filter-box" },
            [
              _c("div", { staticClass: "filter-label" }, [_vm._v("园区范围")]),
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  attrs: { placeholder: "全部园区（可选）", clearable: "" },
                  on: { change: _vm.loadBoardData },
                  model: {
                    value: _vm.query.campus,
                    callback: function($$v) {
                      _vm.$set(_vm.query, "campus", $$v)
                    },
                    expression: "query.campus"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _vm._l(_vm.campusOptions, function(item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { label: item, value: item }
                    })
                  })
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "filter-block filter-box" },
            [
              _c("div", { staticClass: "filter-label" }, [_vm._v("周期类型")]),
              _c(
                "el-select",
                {
                  staticClass: "filter-item",
                  attrs: { placeholder: "请选择周期类型" },
                  on: { change: _vm.handlePeriodTypeChange },
                  model: {
                    value: _vm.query.period,
                    callback: function($$v) {
                      _vm.$set(_vm.query, "period", $$v)
                    },
                    expression: "query.period"
                  }
                },
                _vm._l(_vm.periodOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "period-compare-box" }, [
            _c("div", { staticClass: "period-compare-header" }, [
              _c("span", { staticClass: "current-dot" }),
              _c("span", [_vm._v("当前周期")]),
              _c("span", { staticClass: "vs-text" }, [_vm._v("VS")]),
              _c("span", { staticClass: "compare-dot" }),
              _c("span", [_vm._v("对比周期")])
            ]),
            _c(
              "div",
              { staticClass: "period-compare-row" },
              [
                _c(
                  "el-select",
                  {
                    staticClass: "period-item",
                    attrs: { placeholder: "当前周期" },
                    on: { change: _vm.handleCurrentPeriodChange },
                    model: {
                      value: _vm.query.currentPeriodKey,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "currentPeriodKey", $$v)
                      },
                      expression: "query.currentPeriodKey"
                    }
                  },
                  _vm._l(_vm.periodSelectionOptions, function(item) {
                    return _c("el-option", {
                      key: "c-" + item.key,
                      attrs: { label: item.label, value: item.key }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "period-item",
                    attrs: { placeholder: "对比周期" },
                    on: { change: _vm.loadBoardData },
                    model: {
                      value: _vm.query.comparePeriodKey,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "comparePeriodKey", $$v)
                      },
                      expression: "query.comparePeriodKey"
                    }
                  },
                  _vm._l(_vm.periodSelectionOptions, function(item) {
                    return _c("el-option", {
                      key: "p-" + item.key,
                      attrs: { label: item.label, value: item.key }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "filter-block button-block" },
            [
              _c("div", { staticClass: "filter-label" }, [_vm._v("执行操作")]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.loadBoardData }
                },
                [_vm._v("查询")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "alert-highlight",
              on: { click: _vm.openAlertDrawer }
            },
            [
              _c("div", { staticClass: "alert-title" }, [
                _c("i", { staticClass: "el-icon-bell" }),
                _vm._v("\n          告警工单\n        ")
              ]),
              _c("div", { staticClass: "alert-value" }, [
                _vm._v(_vm._s(_vm.overviewCurrent.alert_orders || 0))
              ]),
              _c("div", { staticClass: "alert-desc" }, [
                _vm._v("进行中且已超时")
              ])
            ]
          )
        ]),
        _vm.filterInfo.current_start
          ? _c("div", { staticClass: "time-range" }, [
              _vm._v(
                "\n      当前周期：" +
                  _vm._s(
                    _vm.formatDateRange(
                      _vm.filterInfo.current_start,
                      _vm.filterInfo.current_end
                    )
                  ) +
                  "，\n      对比周期：" +
                  _vm._s(
                    _vm.formatDateRange(
                      _vm.filterInfo.previous_start,
                      _vm.filterInfo.previous_end
                    )
                  ) +
                  "\n    "
              )
            ])
          : _vm._e()
      ]),
      _c(
        "el-row",
        { staticClass: "mt-20", attrs: { gutter: 16 } },
        _vm._l(_vm.kpiCards, function(item) {
          return _c(
            "el-col",
            { key: item.key, attrs: { span: 4 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "kpi-card",
                  class: { clickable: _vm.isKpiClickable(item.key) },
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleKpiClick(item)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "kpi-title" }, [
                    _c("i", { staticClass: "kpi-icon", class: item.icon }),
                    _vm._v("\n          " + _vm._s(item.title) + "\n        ")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "kpi-value",
                      class: [
                        item.valueClass,
                        { compact: item.key === "overtime_orders" }
                      ]
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getKpiDisplayValue(item)) +
                          "\n        "
                      )
                    ]
                  ),
                  _c("div", { staticClass: "kpi-compare" }, [
                    _c(
                      "span",
                      { class: _vm.getCompareClass(_vm.getCompareValue(item)) },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formatCompareText(_vm.getCompareValue(item))
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-row",
        { staticClass: "mt-20", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("近12个月工单数量趋势")
                ]),
                _c("div", {
                  ref: "monthlyTrendChartRef",
                  staticClass: "chart-box"
                })
              ])
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "card-title" }, [
                  _vm._v("今年园区工单占比")
                ]),
                _c("div", {
                  ref: "campusShareChartRef",
                  staticClass: "chart-box"
                })
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.alertDrawerVisible,
            size: "60%",
            direction: "rtl"
          },
          on: {
            "update:visible": function($event) {
              _vm.alertDrawerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer-header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("span", [_vm._v("告警工单（进行中且已超时）")]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: { click: _vm.exportAlertTickets }
                },
                [_vm._v("导出Excel")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "alert-drawer-body" },
            [
              _c(
                "el-table",
                {
                  attrs: { data: _vm.alertTicketList, border: "", stripe: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "TicketId",
                      label: "工单号",
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Campus", label: "园区", "min-width": "120" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Scene", label: "场景", width: "80" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "超时工单涉及人员", "min-width": "260" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.involved_staff_list &&
                            scope.row.involved_staff_list.length
                              ? _c(
                                  "div",
                                  { staticClass: "staff-tags" },
                                  _vm._l(
                                    scope.row.involved_staff_list,
                                    function(name) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: name,
                                          attrs: {
                                            size: "mini",
                                            type: "info",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(name) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c("span", [_vm._v("-")])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "overtime_hours",
                      label: "超时小时",
                      width: "90"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "CreateTime",
                      label: "创建时间",
                      width: "170"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "OlaTime", label: "OLA时间", width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ProcessTitle",
                      label: "工单标题",
                      "min-width": "220",
                      "show-overflow-tooltip": ""
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrap" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, prev, pager, next, sizes",
                      "current-page": _vm.alertPagination.page,
                      "page-size": _vm.alertPagination.size,
                      "page-sizes": [20, 50, 100],
                      total: _vm.alertPagination.total
                    },
                    on: {
                      "size-change": _vm.handleAlertSizeChange,
                      "current-change": _vm.handleAlertPageChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.overtimeDrawerVisible,
            size: "60%",
            direction: "rtl"
          },
          on: {
            "update:visible": function($event) {
              _vm.overtimeDrawerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer-header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("span", [_vm._v("超时工单（超时率/超时工单数量）")]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: { click: _vm.exportOvertimeTickets }
                },
                [_vm._v("导出Excel")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "alert-drawer-body" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.overtimeTicketList,
                    border: "",
                    stripe: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "TicketId",
                      label: "工单号",
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Campus", label: "园区", "min-width": "120" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Scene", label: "场景", width: "80" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "InstanceStatus",
                      label: "状态",
                      width: "90"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "超时工单涉及人员", "min-width": "260" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.involved_staff_list &&
                            scope.row.involved_staff_list.length
                              ? _c(
                                  "div",
                                  { staticClass: "staff-tags" },
                                  _vm._l(
                                    scope.row.involved_staff_list,
                                    function(name) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: name,
                                          attrs: {
                                            size: "mini",
                                            type: "info",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(name) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c("span", [_vm._v("-")])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "overtime_hours",
                      label: "超时小时",
                      width: "90"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "CreateTime",
                      label: "创建时间",
                      width: "170"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "EndTime", label: "结束时间", width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "OlaTime", label: "OLA时间", width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ProcessTitle",
                      label: "工单标题",
                      "min-width": "220",
                      "show-overflow-tooltip": ""
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrap" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, prev, pager, next, sizes",
                      "current-page": _vm.overtimePagination.page,
                      "page-size": _vm.overtimePagination.size,
                      "page-sizes": [20, 50, 100],
                      total: _vm.overtimePagination.total
                    },
                    on: {
                      "size-change": _vm.handleOvertimeSizeChange,
                      "current-change": _vm.handleOvertimePageChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.kpiDrawerVisible,
            size: "60%",
            direction: "rtl",
            "destroy-on-close": true
          },
          on: {
            "update:visible": function($event) {
              _vm.kpiDrawerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer-header",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.kpiDrawerTitle))]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary", plain: "" },
                  on: { click: _vm.exportKpiDetailTickets }
                },
                [_vm._v("导出Excel")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "alert-drawer-body" },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.kpiTicketList, border: "", stripe: "" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "TicketId",
                      label: "工单号",
                      "min-width": "140"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Campus", label: "园区", "min-width": "120" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "Scene", label: "场景", width: "80" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "InstanceStatus",
                      label: "状态",
                      width: "110"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "CreateTime",
                      label: "创建时间",
                      width: "170"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "OlaTime", label: "OLA时间", width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "EndTime", label: "结束时间", width: "170" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ProcessTitle",
                      label: "工单标题",
                      "min-width": "220",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "涉及人员", "min-width": "260" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.involved_staff_list &&
                            scope.row.involved_staff_list.length
                              ? _c(
                                  "div",
                                  { staticClass: "staff-tags" },
                                  _vm._l(
                                    scope.row.involved_staff_list,
                                    function(name) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: name,
                                          attrs: {
                                            size: "mini",
                                            type: "info",
                                            effect: "plain"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(name) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _c("span", [_vm._v("-")])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrap" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, prev, pager, next, sizes",
                      "current-page": _vm.kpiPagination.page,
                      "page-size": _vm.kpiPagination.size,
                      "page-sizes": [20, 50, 100],
                      total: _vm.kpiPagination.total
                    },
                    on: {
                      "size-change": _vm.handleKpiSizeChange,
                      "current-change": _vm.handleKpiPageChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }